import Legal1 from "../../legal/documents/LegalMtr.vue";
import DocumentList1 from "../documents/DocumentListMagyt.vue";
import layouts from "../../../../layout";

export default {
  path: "/legalmtr",
  name: "legal",
  component: Legal1,
  meta: {
    auth: true
  },
  redirect: {
    name: "legal-documentMTR"
  },
  children: [
    {
      path: "documentsMTR",
      name: "legal-documentMTR",
      component: DocumentList1,
      meta: {
        auth: true,
        searchable: true,
        layout: layouts.navLeft,
        title: "Documents",
        tags: ["legal", "documents"],
        index: true
      }
    }
  ]
};
